import * as types from "../constants/actionTypes";

export const changeMobileViewFlag = flag => {
  return {
    type: types.CHANGE_MOBILEVIEW_FLAG,
    payload: flag
  };
};



// WEBPACK FOOTER //
// ./src/actions/mobileViewActions.js